export default {
  audioFile: {
    fileSize: 'File Size',
    musicDuration: 'Music Duration',
    cutting: '剪辑',
    duration: '获取中...',
  },
  audioLoop: {
    title: '播放',
    playSetting: '播放设置',
    autoPlay: '入场自动播放',
    cycles: '播放次数',
    formItemList: {
      loopNumber: '次',
      loop: '无限循环',
    },
  },
  audioSetting: {
    soundEffect: '音效',
    volume: '音量',
  },
  audioEditor: {
    argumentsAreEmpty: 'url 是必传参数',
  },
  dialog: {
    title: '音频剪辑',
    soundTitle: '音效裁剪',
  },
}
